/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M12 20.9999C16.9706 20.9999 21 16.9705 21 11.9999C21 11.3668 20.9346 10.749 20.8103 10.1528"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12 21C7.66249 21 4.04167 17.9316 3.18969 13.8471M20.8102 10.1529C22.2951 8.46192 22.9387 6.94653 22.3922 6.00001C21.8456 5.05317 20.2106 4.85301 18.0026 5.29404M20.8102 10.1529C19.2938 11.8798 16.8999 13.7898 13.9999 15.4641C8.26043 18.7778 2.71221 19.9132 1.60764 18C1.06115 17.0535 1.70475 15.5381 3.18969 13.8471M20.8102 10.1529C20.4113 8.2402 19.4052 6.55034 18.0026 5.29404M18.0026 5.29404C16.41 3.86752 14.3063 3 12 3C7.02941 3 2.99997 7.02944 2.99997 12C2.99997 12.6331 3.06534 13.2509 3.18969 13.8471"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M3.00003 12C3.00003 7.02944 7.02947 3 12 3C14.3064 3 16.4101 3.86752 18.0027 5.29404C20.2106 4.85301 21.8457 5.05317 22.3923 6.00001C22.9388 6.94653 22.2952 8.46192 20.8103 10.1529C19.2938 11.8798 16.8999 13.7898 14 15.4641C11.101 17.1378 8.25082 18.2558 5.99739 18.706C3.78941 19.147 2.15436 18.9468 1.6077 18C1.06121 17.0535 1.70481 15.5381 3.18975 13.8471C3.0654 13.2509 3.00003 12.6331 3.00003 12Z"
				fill="currentColor"
			/>
			<path
				d="M20.8103 10.1529C22.2952 8.46192 22.9388 6.94653 22.3923 6.00001C21.8457 5.05317 20.2106 4.85301 18.0027 5.29404M20.8103 10.1529C19.2938 11.8798 16.8999 13.7898 14 15.4641C8.26049 18.7778 2.71227 19.9132 1.6077 18C1.06121 17.0535 1.70481 15.5381 3.18975 13.8471M20.8103 10.1529C20.9347 10.7491 21 11.3669 21 12C21 16.9706 16.9706 21 12 21C7.66255 21 4.04173 17.9316 3.18975 13.8471M20.8103 10.1529C20.4113 8.2402 19.4052 6.55034 18.0027 5.29404M18.0027 5.29404C16.4101 3.86752 14.3064 3 12 3C7.02947 3 3.00003 7.02944 3.00003 12C3.00003 12.6331 3.0654 13.2509 3.18975 13.8471"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.0001 2.25C6.61534 2.25 2.25012 6.61523 2.25012 12C2.25012 12.5563 2.29671 13.1017 2.38619 13.6325C1.73047 14.418 1.22663 15.1958 0.938823 15.9288C0.620383 16.7398 0.522501 17.6206 0.958174 18.3752C1.39847 19.1378 2.22249 19.4929 3.09536 19.6193C3.97888 19.7473 5.04972 19.6658 6.2161 19.4271C8.55697 18.948 11.4549 17.7997 14.375 16.1138C17.3256 14.4103 19.7899 12.4517 21.3739 10.6479C22.1468 9.76771 22.7392 8.89161 23.0612 8.07155C23.3796 7.26054 23.4775 6.37976 23.0418 5.62516C22.606 4.87032 21.7939 4.51471 20.932 4.38507C20.1532 4.26794 19.2276 4.3155 18.2193 4.49075C16.5315 3.09127 14.364 2.25 12.0001 2.25ZM19.5548 5.83603C20.2114 6.63971 20.7422 7.55009 21.1173 8.53718C21.3624 8.16925 21.5448 7.82922 21.665 7.52333C21.9029 6.91727 21.8536 6.56709 21.7428 6.37516C21.6319 6.18317 21.3532 5.96529 20.7089 5.86839C20.3834 5.81943 19.9969 5.8075 19.5548 5.83603ZM4.44564 18.1643C3.78901 17.3605 3.2581 16.45 2.88294 15.4628C2.6377 15.8309 2.45519 16.171 2.33505 16.477C2.09708 17.0831 2.1464 17.4332 2.25721 17.6252C2.36921 17.8191 2.65292 18.0396 3.31037 18.1348C3.63223 18.1814 4.01234 18.1923 4.44564 18.1643ZM12.0001 21.75C10.224 21.75 8.55884 21.2751 7.12464 20.4453L7.21617 20.4269C9.55703 19.9479 12.4549 18.7996 15.3751 17.1136C17.9597 15.6214 20.1713 13.9334 21.7448 12.3252C21.5733 17.5594 17.2761 21.75 12.0001 21.75Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M20.8102 10.1529C22.2951 8.46192 22.9387 6.94653 22.3922 6.00001C21.8456 5.05317 20.2106 4.85301 18.0026 5.29404M20.8102 10.1529C19.2938 11.8798 16.8999 13.7898 13.9999 15.4641C13.6657 15.6571 13.3321 15.8427 13 16.0207M20.8102 10.1529C20.9346 10.7491 21 11.3669 21 12C21 16.9706 16.9705 21 12 21C7.66249 21 4.04167 17.9316 3.18969 13.8471M20.8102 10.1529C20.4113 8.2402 19.4052 6.55034 18.0026 5.29404M18.0026 5.29404C16.41 3.86752 14.3063 3 12 3C7.02941 3 2.99997 7.02944 2.99997 12C2.99997 12.6331 3.06534 13.2509 3.18969 13.8471M3.18969 13.8471C1.70475 15.5381 1.06115 17.0535 1.60764 18C2.38077 19.3391 5.33097 19.1847 8.99999 17.8351"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M20.8102 10.1529C22.2951 8.46192 22.9387 6.94653 22.3922 6.00001C21.8456 5.05317 20.2106 4.85301 18.0026 5.29404M20.8102 10.1529C19.2938 11.8798 16.8999 13.7898 13.9999 15.4641C8.26043 18.7778 2.71221 19.9132 1.60764 18C1.06115 17.0535 1.70475 15.5381 3.18969 13.8471M20.8102 10.1529C20.9346 10.7491 21 11.3669 21 12C21 16.9706 16.9705 21 12 21C7.66249 21 4.04167 17.9316 3.18969 13.8471M20.8102 10.1529C20.4113 8.2402 19.4052 6.55034 18.0026 5.29404M18.0026 5.29404C16.41 3.86752 14.3063 3 12 3C7.02941 3 2.99997 7.02944 2.99997 12C2.99997 12.6331 3.06534 13.2509 3.18969 13.8471"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M7.12463 20.4454C8.55884 21.2751 10.224 21.75 12.0001 21.75C17.2761 21.75 21.5733 17.5595 21.7448 12.3252C20.1713 13.9334 17.9597 15.6214 15.3751 17.1137C12.4549 18.7996 9.55703 19.9479 7.21616 20.4269C7.18559 20.4332 7.15507 20.4393 7.12463 20.4454Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.0002 2.25C6.61538 2.25 2.25015 6.61523 2.25015 12C2.25015 12.5563 2.29674 13.1017 2.38622 13.6325C1.73048 14.418 1.22663 15.1957 0.938823 15.9287C0.620383 16.7397 0.522501 17.6205 0.958174 18.3752C1.39847 19.1378 2.22249 19.4929 3.09536 19.6193C3.97888 19.7472 5.04972 19.6657 6.2161 19.4271C8.55697 18.948 11.4549 17.7997 14.375 16.1138C17.3256 14.4103 19.7899 12.4517 21.3739 10.6479C22.1468 9.76769 22.7392 8.89159 23.0612 8.07153C23.3796 7.26053 23.4775 6.37975 23.0418 5.62515C22.606 4.87031 21.7939 4.51469 20.932 4.38506C20.1532 4.26793 19.2276 4.31548 18.2194 4.49074C16.5315 3.09127 14.3641 2.25 12.0002 2.25ZM19.5549 5.83601C20.2114 6.63969 20.7422 7.55006 21.1173 8.53714C21.3624 8.16922 21.5449 7.8292 21.665 7.52332C21.9029 6.91725 21.8536 6.56708 21.7428 6.37515C21.6319 6.18316 21.3532 5.96528 20.7089 5.86838C20.3834 5.81942 19.997 5.80748 19.5549 5.83601ZM4.44566 18.1643C3.78902 17.3605 3.25812 16.45 2.88296 15.4628C2.63771 15.8308 2.45519 16.171 2.33505 16.477C2.09708 17.083 2.1464 17.4332 2.25721 17.6252C2.36921 17.8191 2.65292 18.0395 3.31037 18.1348C3.63223 18.1814 4.01235 18.1922 4.44566 18.1643Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
